<div class="vehicle-main container">
    <mat-label class="vehicle-header">{{ 'vehicleInquiry.vehiclesOfInterest' | translate}}</mat-label>
    <div [formGroup]='inquiryVehicle' class="inquiry-vehicle-main">
        <div formGroupName='vehicleType' class="trans-checkbox-options">
            <mat-checkbox class="trans-checkbox" formControlName="new" ngDefaultControl >
                <span class="checkbox-text">{{ 'vehicleInquiry.new' | translate}}</span>
            </mat-checkbox>
            <mat-checkbox class="trans-checkbox" formControlName="used" ngDefaultControl >
                <span class="checkbox-text">{{(isLexus ? 'otherTexts.preOwned' : 'vehicleInquiry.used') | translate}}</span>
            </mat-checkbox>
            <mat-checkbox class="trans-checkbox" formControlName="both" (change)="checkUncheckBoth($event)" ngDefaultControl >
                <span class="checkbox-text">{{ 'vehicleInquiry.both' | translate}}</span>
            </mat-checkbox>  
            <div class="invalid-feedback" *ngIf="inquiryVehicle.controls['vehicleType'].errors && inquiryVehicle.controls['vehicleType'].errors.requireCheckboxesToBeChecked">At least one checkbox is required to check</div>
        </div>

        <app-splitter class="app-splitter d-block" [config]="'horizontal 50% 0 .4rem'"></app-splitter>
        
        <div formGroupName='vehiclesOfInterest' class="trans-checkbox-options">
            <mat-checkbox class="trans-checkbox" formControlName="carsMinivan" ngDefaultControl >
                <span class="checkbox-text">{{ 'vehicleInquiry.carsAndMinivan' | translate}}</span>
            </mat-checkbox>
            <mat-checkbox class="trans-checkbox" formControlName="trucks" ngDefaultControl >
                <span class="checkbox-text">{{ 'vehicleInquiry.trucks' | translate}}</span>
            </mat-checkbox>
            <mat-checkbox class="trans-checkbox" formControlName="crossoversSuv" ngDefaultControl >
                <span class="checkbox-text">{{ 'vehicleInquiry.crossoversAndSUVs' | translate}}</span>
            </mat-checkbox>   
            <mat-checkbox class="trans-checkbox" formControlName="electrified" ngDefaultControl >
                <span class="checkbox-text">{{ 'vehicleInquiry.electrified' | translate}}</span>
            </mat-checkbox>
        </div>
    </div>
</div>

